function r(n) {
  return function(e) {
    return n == null ? void 0 : n[e];
  };
}
export {
  r as default
};
